// Core components
import { Component, SimpleChange } from "@angular/core";
import { MatDialog } from "@angular/material";

// Third party components
import { FieldArrayType } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject, Subscription } from "rxjs";

// Custom components

/**
 * Script start
 */
@Component({
  selector: "formly-doc-repeat-section",
  templateUrl: "./repeat-doc-type.component.html",
  styleUrls: ["./repeat-doc-type.component.scss"]
})
export class RepeatDocTypeComponent extends FieldArrayType {
  private subscriptions: Subscription[] = [];
  onDestroy$ = new Subject<void>();
  private availableOptions: any[] | Observable<any[]> = [];
  private delBntenable= true;

  constructor(
    private translateService: TranslateService,
    private dialog: MatDialog
  ) {
    super();
  }

  /**
   * Init component
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    this.to.add = this.add.bind(this);
    this.to.remove = this.remove.bind(this);
  }

  /**
   * Listen on input values changes
   *
   * @since 1.0.0
   */
  ngOnChanges(changes: SimpleChange): void {

  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  

  /**
   * Handle click on "add new row" button and add a new row's input template
   *
   * @since 1.0.0
   */
  onAddRow(): void {
    this.add();

    // this.add(null, {});
  }
}
